var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
define('tracks/virtual-track',["require", "exports", "../studio/laser-parse", "../util/convert", "./track"], function (require, exports, laser_parse_1, convert_1, tracker) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.wseTrack = exports.laserTrack = void 0;
    /**
     * Turns a laser profile into a virtual track
     */
    function laserTrack(laser) {
        // Prepend 0,0 to all profiles
        var zero = { x: 0, y: 0 };
        var points = (0, laser_parse_1.reorder)(__spreadArray([zero], laser.points, true))
            .map(function (p) {
            return {
                x: convert_1.default.distance.localValue(p.x),
                y: convert_1.default.distance.localValue(p.y),
                distance: convert_1.default.distance.localValue(p.x)
            };
        });
        var track = tracker.fromJson({
            track_id: laser.laser_id,
            data: points,
            place: laser.place,
            stats: {},
            trim: {}
        });
        track.trackType = "laser";
        track.niceString = function () { return laser.name; };
        return track;
    }
    exports.laserTrack = laserTrack;
    /**
     * Turns a generated list of WSE points into a virtual track
     */
    function wseTrack(wspoints) {
        var first11_x;
        var first11_y;
        var cross11;
        var feather;
        var lastPoint;
        var points = wspoints
            .map(function (p) {
            // Start metrics
            if (first11_x === undefined && p.y < -5 && -p.vx / p.vy > 1) {
                first11_x = p.x;
                first11_y = -p.y;
            }
            if (cross11 === undefined && p.y < -5 && -p.y <= p.x) {
                if (lastPoint) {
                    // Interpolate from last point to find x = y
                    if (p.x === lastPoint.x) {
                        cross11 = p.x;
                    }
                    else {
                        var slope = (lastPoint.y - p.y) / (lastPoint.x - p.x);
                        var intercept = (-p.y - slope * p.x) / (1.0 - slope);
                        cross11 = intercept;
                    }
                }
                else {
                    cross11 = p.x;
                }
            }
            if (feather === undefined && p.y <= -200) {
                if (lastPoint) {
                    // Interpolate from last point to find y = 200
                    var slope = (lastPoint.y - p.y) / (lastPoint.x - p.x);
                    var intercept = -(200 + p.y) / slope + p.x;
                    feather = intercept;
                }
                else {
                    feather = p.x;
                }
            }
            lastPoint = p;
            return {
                millis: p.millis,
                x: p.x,
                y: p.y,
                distance: p.x,
                climb: p.vy,
                vN: p.vx,
                vE: 0
            };
        });
        var track = tracker.fromJson({
            track_id: "WSE generated",
            data: points,
            place: {
                objectType: "E"
            },
            stats: {
                first11_x: first11_x,
                first11_y: first11_y,
                cross11: cross11,
                feather: feather
            },
            trim: {}
        });
        track.trackType = "wse";
        track.niceString = function () { return "WSE"; };
        return track;
    }
    exports.wseTrack = wseTrack;
});
//# sourceMappingURL=/assets/javascripts/tracks/virtual-track.js.map;
